import React from 'react';
import Api from "../services/Api";
import ModalHeader from '../components/ModalHeader';
import { History } from "history";
import { IonButton, IonContent, IonPage, withIonLifeCycle } from '@ionic/react';
import { SafetyPadding } from '../components/SafetyPadding';


interface ComponentProps {
  reloadData: Function
  history: History;
}

interface ComponentState {
  done: boolean;
}

class Disabled extends React.Component<ComponentProps, ComponentState> {
  private api = Api.getInstance();

  state = {
    done: false
  }

  private resendVerification() {
    this.api.get('verification/send_mail').then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          this.setState({
            done: true
          });
        }
      })
    });
  }

  closeModal = () => {
    this.props.history.goBack()
  }

  render() {
    return (
      <IonPage className="cheap_desktop">
        <ModalHeader 
          pageTitle={this.api.tr('verify_account')}
          closeModal={this.closeModal}/>
        <IonContent>
          <section className="mx-4 pt-8 ">
            {/* <h2 className="text_center">Verifiera adress</h2> */}
            {
              !this.state.done ? (
                <section className="infoSpace mt-4 box_shadow p-2">
                  {/* <h2 className="text_center">
                    Din epost-adress har inte verifierats.
                  </h2> */}
                  <h2 className="mt-4 text_center color_green">
                    {this.api.tr('verify_account_header')} 
                  </h2>
                  <ol className="mx-4 mt-4">
                    <li>{this.api.tr('verify_account_step1')} </li>
                    <li>{this.api.tr('verify_account_step2')} </li>
                  </ol>
                  <IonButton 
                    expand="block" 
                    className="mt-8"
                    onClick={() => {
                      window.location.reload()
                      return false
                    }}>
                    {this.api.tr('verified_confirmation')}
                  </IonButton>
                  <p className="mt-8">
                    {this.api.tr('verified_help')}
                  </p>
                  {/* <div className="mt-4 color_green text_center" onClick={() => this.resendVerification()}>
                    Skicka nytt verifieringsmail
                  </div> */}

                  <IonButton 
                    expand="block" 
                    className="mt-2"
                    fill="outline"
                    onClick={() => this.resendVerification()}>
                    {this.api.tr('send_new_verify')}
                  </IonButton>
                </section>
              ) : (
                <div className="mt-8 infoSpace mt-4 box_shadow">
                  <h2>
                    {this.api.tr('new_verified_header')}
                  </h2>
                  <article className="infoArea">
                    <h3 className="text_center">{this.api.profile.email}</h3>
                  </article>

                  <p className="mt-4">
                    {this.api.tr('verified_followed')}
                  </p>
                  <IonButton 
                    className="mt-8" 
                    expand="block" 
                    onClick={() => {
                      window.location.reload()
                      return false
                    }}>
                    {this.api.tr('done')}
                  </IonButton>
                  <p className="mt-8 color_grey">
                    {this.api.tr('verified_issues_help')}
                  </p>
                </div>
              )
            }
          </section>
          <SafetyPadding/>
        </IonContent>
      </IonPage>
    );
  }
}

export default withIonLifeCycle(Disabled);
